import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totals: {
        total: 0,
        subTotal: 0,
        tax: 0
    },
    itemCount: 0,
    items: [],
    visible: false,
    loading: false
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        setCartTotals: (state, action) => {
            state.totals.total = action.payload.total;
            state.totals.subTotal = action.payload.subTotal;
            state.totals.tax = action.payload.tax;
        },
        setCartItems: (state, action) => {
            state.itemCount = action.payload.itemCount || state.itemCount;
            state.items = action.payload.items;
        },
        toggleVisibility: (state, action) => {
            state.visible = action.payload;
        },
        toggleLoading: (state, action) => {
            state.loading = action.payload;
        },
        clearCart: (state) => {
            state.totals = initialState.totals;
            state.itemCount = initialState.itemCount;
            state.items = initialState.items;
            state.visible = false;
            state.loading = false;
        }
    }
});

export const { setCartTotals, setCartItems, toggleVisibility, toggleLoading, clearCart } = cartSlice.actions;
export default cartSlice.reducer;